export class HomepageContentDetails {
  eventTitle:string = '';
  weeklyEconomicSummary:string = '';
  currencyExchangeTitle:string = '';
}

export class HomepageContentModel {
  flatData: HomepageContentDetails = new HomepageContentDetails();
}